import { useAccount } from 'Account/hooks/account';
import { Alert, Button } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  isBillingAddressComplete,
  isTaxInformationComplete,
} from 'ShorePay/utils';

const AccountAddressChecker: React.FC = () => {
  const accQuery = useAccount();

  if (accQuery.isSuccess) {
    const { data } = accQuery;
    if (
      isBillingAddressComplete(data.billing_address) &&
      isTaxInformationComplete({
        tax_number: data.tax_number,
        vat_number: data.vat_number,
      })
    ) {
      return null;
    }
    return (
      <Alert
        showIcon
        css={`
          .ant-alert-message {
            color: rgba(0, 0, 0, 0.65);
          }
          > .anticon {
            color: #fed8a6;
          }
        `}
        type="warning"
        message={
          <div
            data-testid="check-fail-msg"
            css="display: flex; justify-content: space-between"
          >
            <span css="display: flex; align-items: center">
              <FormattedMessage defaultMessage="Your address information is incomplete. Please fill your billing and store address before purchasing a new reader." />
            </span>
            <Button
              data-testid="open-settings-btn"
              size="small"
              css="padding: 0 15px"
              href="/settings/store"
            >
              <FormattedMessage defaultMessage="Open Settings" />
            </Button>
          </div>
        }
      />
    );
  }

  return null;
};

export default AccountAddressChecker;
